// extracted by mini-css-extract-plugin
export var hideEditor = "_jp-2";
export var infoIcon = "_jp-3";
export var label = "_jp-1";
export var labelContainer = "_jp-0";
export var readonlyText = "_jp-4";